import { API_ORIGIN } from '../../../config/apiConfig';

export const unwrapData = (payload) => {
  if (payload && Object.prototype.hasOwnProperty.call(payload, 'data')) {
    return payload.data;
  }
  return payload;
};

export const unwrapList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.results)) {
    return payload.results;
  }

  if (Array.isArray(payload?.data?.results)) {
    return payload.data.results;
  }

  return [];
};

export const unwrapPaginated = (payload) => {
  const items = unwrapList(payload);
  const pagination = payload?.pagination || payload?.data?.pagination || {};

  return {
    items,
    count:
      payload?.count ??
      payload?.data?.count ??
      pagination.count ??
      items.length,
    next: payload?.next ?? payload?.data?.next ?? pagination.next ?? null,
    previous:
      payload?.previous ??
      payload?.data?.previous ??
      pagination.previous ??
      null,
    totalPages:
      pagination.total_pages ??
      payload?.total_pages ??
      payload?.data?.total_pages ??
      null,
  };
};

const flattenErrors = (value) => {
  if (!value) return [];
  if (typeof value === 'string') return [value];
  if (Array.isArray(value)) return value.flatMap(flattenErrors);
  if (typeof value === 'object') {
    return Object.entries(value).flatMap(([key, child]) =>
      flattenErrors(child).map((message) => `${key}: ${message}`),
    );
  }
  return [String(value)];
};

export const getApiErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.',
) => {
  const payload = error?.response?.data;

  if (typeof payload === 'string' && payload.trim()) {
    return payload;
  }

  if (payload?.message) {
    return payload.message;
  }

  const errors = flattenErrors(payload?.errors || payload);
  if (errors.length > 0) {
    return errors.join(' | ');
  }

  return error?.message || fallback;
};

export const resolveAssetUrl = (value) => {
  if (!value) return '';
  if (/^https?:\/\//i.test(value) || value.startsWith('blob:')) return value;
  return `${API_ORIGIN}${value.startsWith('/') ? '' : '/'}${value}`;
};
